import { useCallback } from 'react';
import { useMapStore } from '../../stores/map/useMapStore';

export function useMapActions() {

    const {
        selectedPoint,
        setSelectedPoint,
        setMapFocus,
        setOpenMap
    } = useMapStore();

    const blurPoint = useCallback(() => {

        setSelectedPoint(null);

        setMapFocus({
            type: 'bounds',
        });

    }, [
        setSelectedPoint,
        setMapFocus,
    ]);

    const focusPoint = useCallback((ponto) => {

        const ref =
            ponto?.pontoReferencia;

        if (!ref) {
            return;
        }

        setMapFocus({
            type: 'point',
            lat: Number(ref.LATITUDE),
            lng: Number(ref.LONGITUDE),
            zoom: 15,
            ponto
        });

    }, [
        setMapFocus
    ]);

    const pointClick = useCallback((ponto) => {

        if (selectedPoint?.PONTO_UID === ponto.PONTO_UID) {

            blurPoint();
            return;
        }

        const ref = ponto?.pontoReferencia;

        if (!ref) {
            return;
        }

        setSelectedPoint(ponto);

        focusPoint(ponto);

    }, [
        focusPoint,
        blurPoint,
        selectedPoint,
        setSelectedPoint
    ]);

    const openMapAndPoint = useCallback((codigo, ponto, tripData) => {

        setOpenMap({
            modeMap: 'trip',
            codigoMap: codigo,
            tripData
        });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    pointClick(ponto);
                }, 100);
            });            
        });
        

    }, [
        pointClick,
        setOpenMap
    ]);

    const focusVehicle = useCallback(() => {

        setSelectedPoint(null);

        setMapFocus({
            type: 'vehicle'
        });

    }, [
        setSelectedPoint,
        setMapFocus
    ]);

    const focusPezinhoPosition = useCallback((position) => {

        const lat =
            Number(position?.latitude);

        const lng =
            Number(position?.longitude);

        if (
            !Number.isFinite(lat) ||
            !Number.isFinite(lng)
        ) {
            return;
        }

        setMapFocus({
            type: 'pezinho-position',
            lat,
            lng,
            zoom: 16,
            position
        });

    }, [
        setMapFocus
    ]);

    return {
        focusPezinhoPosition,
        focusVehicle,
        openMapAndPoint,
        blurPoint,
        pointClick,
        focusPoint,
    };

}